import React from 'react';
import SettingsMenu from 'views/admin/main/account/component/SettingsMenu';
import ProductionWorkflowConfig from 'components/production/ProductionWorkflowConfig';

/**
 * Configuration page for the production workflow
 * Allows users to configure their own workflow (1, 2, or 3 steps)
 * and define custom fields
 */
const ProductionSettings = () => {
    return (
        <div className="mt-3 h-full w-full">
            {/* Settings navigation menu */}
            <SettingsMenu path="/settings/production" />

            {/* Page header */}
            <div className="mt-6 mb-6">
                <h1 className="text-2xl font-bold text-navy-700 dark:text-white">
                    Configuration de la Production
                </h1>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                    Configurez votre workflow de production et définissez les étapes de
                    contrôle personnalisées avant la mise en stock.
                </p>
            </div>

            {/* Workflow configuration component */}
            <ProductionWorkflowConfig />
        </div>
    );
};

export default ProductionSettings;
